import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const DokumenPemusnahanPage = lazy(() => import('./pages/dokumen-pemusnahan'))
const DetailPemusnahanPage = lazy(() => import('./pages/detail-pemusnahan'))
const PemusnahanOperatorPage = lazy(() => import('./pages/pemusnahan-operator'))

/** Cluster C12 Pemusnahan FG — DSP-01 (dokumen), DSP-01A (daftar + detail `:id`), DSP-02 (operator mobile). */
const destructionFgRoutes: RouteObject[] = [
  {
    path: 'destruction-fg',
    children: [
      { path: 'dokumen-pemusnahan', element: <DokumenPemusnahanPage /> },
      {
        path: 'detail-pemusnahan',
        children: [
          { index: true, element: <DetailPemusnahanPage /> },
          { path: ':id', element: <DetailPemusnahanPage /> }
        ]
      },
      { path: 'pemusnahan-operator', element: <PemusnahanOperatorPage /> }
    ]
  }
]

export default destructionFgRoutes
